import CrudeSummaryEnts from './crudeSummaryEnts';

export default CrudeSummaryEnts;